import { useClassName } from '@/styles/CoverBox';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type CoverBoxGroupProps = ComponentProps<'div'>;

export const CoverBoxGroupComponent: Component<CoverBoxGroupProps> = ({ children, ...props }) => {
  const className = useClassName('group', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
